import React from "react";
import { useLocale } from "@/contexts/LocaleContext";

export default function LanguageSwitcher({ className = "", testid = "lang-switch" }) {
  const { locale, setLocale, supported } = useLocale();
  return (
    <div
      data-testid={testid}
      className={`inline-flex border border-border rounded-full p-0.5 text-xs ${className}`}
      role="group"
      aria-label="Language switcher"
    >
      {supported.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLocale(code)}
          aria-pressed={locale === code}
          data-testid={`${testid}-${code}`}
          className={`px-3 py-1 rounded-full uppercase tracking-widest transition ${
            locale === code
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {code}
        </button>
      ))}
    </div>
  );
}
